import { useState, useRef, useEffect } from "react";
import './FormInbox.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { collection, doc, getDoc, addDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase/firebaseConfig';  // Firestore configurado
import { useParams } from "react-router-dom"; // Para pegar o token na URL

export default function FormInbox({ onClose }) {
    const [mensagem, setMensagem] = useState('');
    const userEmail = auth.currentUser?.email;
    const { token } = useParams();  // Pega o token da URL
    const formRef = useRef(null);
    const [erro, setErro] = useState(null);
    const [clienteIdToken, setClieteIdToken] = useState(null);


    useEffect(() => {
        if (token) {
            // Aqui você busca os dados do token, como clientId e userEmail
            async function validarToken() {
                try {
                    const docRef = doc(db, 'tokens', token);
                    const docSnap = await getDoc(docRef); // Função getDoc agora está importada

                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setClieteIdToken(data.clienteId);
                        // Buscar as mensagens do cliente com base no clienteId e userEmail
                        //buscarInboxPorCliente(clienteId, emailAdvogado);
                    } else {
                        setErro("Token inválido ou expirado.");
                    }
                } catch (error) {
                    console.error("Erro ao validar token: ", error);
                    setErro("Erro ao validar token.");
                }
            }

            validarToken();
        }
    }, [token]);

    // Função para salvar ou atualizar a mensagem com o CPF do cliente
    const handleSave = async () => {

        // Verifica se a mensagem está vazia
        if (!mensagem.trim()) {
            console.error('A mensagem não pode estar vazia!');
            return; // Sai da função se a mensagem estiver vazia
        }

        // Recupera o cliente atual do sessionStorage
        const clienteAtual = sessionStorage.getItem('clienteSelecionado');
        const cliente = clienteAtual ? JSON.parse(clienteAtual) : null;

        try {
            if (!token) {
                // Adiciona um novo evento com a mensagem e o CPF do cliente atual
                await addDoc(collection(db, `usuarios/${userEmail}/inbox`), {
                    mensagem,
                    dono: "advogado",
                    clienteId: cliente.id, // Salva o CPF junto com a mensagem
                    timestamp: new Date() // Adiciona um timestamp para registro
                });
          
                onClose(); // Fecha o formulário após o salvamento
            }
            if (token) {
                // Adiciona um novo evento com a mensagem e o CPF do cliente atual
                await addDoc(collection(db, `usuarios/${userEmail}/inbox`), {
                    mensagem,
                    dono: "cliente",
                    clienteId: clienteIdToken, // Salva o CPF junto com a mensagem
                    timestamp: new Date() // Adiciona um timestamp para registro
                });
              
                onClose(); // Fecha o formulário após o salvamento
            }

        } catch (error) {
            console.error('Erro ao salvar a mensagem: ', error);
        }
    };


    return (

        <div className="fundo-container-form-inbox" ref={formRef}>

            <div className="container-form-inbox">
                <div className="form-header-inbox">
                    <p className="mb-4-inbox">Adicionar Mensagem</p>
                    <button onClick={onClose} className="btn-close-form-inbox">
                        <FontAwesomeIcon icon={faTimes} size='2x' />
                    </button>
                </div>
                <div className="container-input-form-inbox">
                    <textarea
                        rows="4"
                        cols="50"
                        placeholder="Digite sua mensagem aqui..."
                        value={mensagem}
                        onChange={(e) => setMensagem(e.target.value)}
                        className="input-inbox"
                        type="text"
                    ></textarea>
                </div>
                <button
                    className="btn-salvar-form-inbox"
                    onClick={handleSave}>
                    Salvar
                </button>
            </div>

        </div>

    );
}
